import { graphql } from "@/lib/gql/__generated__";

export const HostReceiptDownloadURL_ManagementSalesReceiptsPage_Query = graphql(`
	query HostReceiptDownloadURL_ManagementSalesReceiptsPage(
		$hotelID: ID!
		$receiptType: HostReceiptType!
		$uniqueID: ID!
	) {
		hostReceiptDownloadURL(hotelID: $hotelID, receiptType: $receiptType, uniqueID: $uniqueID)
	}
`);
